export default "__VITE_PUBLIC_ASSET__34b32bb2__"